module.exports = __webpack_public_path__ + "static/media/ng.e05e70d4.mp3";